export default {
    path: '/offer',
    name: 'Offer',
    meta: {
        title: 'Оферта',
        forVisitors: true
    },
    component: () => import('@/views/info_pages/offer'),
}